import styled from 'styled-components'

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

export const LoadingIconWrapper = styled.div`
  & > svg {
    transition: opacity 1s ease-in-out;
  }
`
